$(document).ready(function(){
  
  $('.sub2').each(function(){
    if ($(this).children('li').length == 0) {
    	$(this).parent('li').hide();
    }
  });
  
  $("#blog img:not(.grid_img)").unwrap();
  $("#blog img:not(.grid_img)").each(function(i){  
  	 if( i % 2 == 0 ) {
        $(this).nextAll('img').andSelf().slice(0,2).wrapAll('<div class="slide"></div>');
     	} 	
  	});
  
  
  $("#article img:not(.grid_img)").unwrap(); 
  
  $("#article img:not(.grid_img)").each(function(i){  
  	 if( i % 2 == 0 ) {
        $(this).nextAll('img').andSelf().slice(0,2).wrapAll('<div class="slide"></div>');
     	} 	
  	});
  
  function getQueryVariable(variable)
{
       var query = window.location.search.substring(1);
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return pair[1];}
       }
       return(false);
}


   function addItem(form_id) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#'+form_id).serialize(),
        success: Shopify.onSuccess,
        error: Shopify.onError
      });
   }

     $(document).on("click",".addtocart",function(event){   
      var elem = $(this)
      $(elem).prop("disabled", true)
      event.preventDefault();
      var $id=$(this).parents("form").data("formid");
      addItem('add-item-form'+$id);
     
   });
  
  $("#shop").hover(function(e){
    e.preventDefault();
  	$(this).find('.sub').toggle();
  });
  
  $(".coll").mouseover(function(){
    $('.types').hide();
  	$(this).find('.types').show();
  });
  
  $('.types').mouseout(function(){
    $(this).hide();
  });
  
  $('.pagination li a').each(function(){
  	var q = getQueryVariable("q");
    var href = $(this).attr('href');
    var newhref = href + "&q="+q;
    if( $(this).hasClass('next') || $(this).hasClass('prev')){
   $(this).attr('href',href);
    } else {
       $(this).attr('href',newhref);
    }
  });
  

  $("#designers").hover(function(e){
     e.preventDefault();
  	$(this).find('.sub, .sub2').toggle();
  });
  
   Shopify.onSuccess = function() {
     
      var elem = $('.addtocart');
      elem.removeAttr("disabled"); 
      var quantity = parseInt(jQuery('[name="quantity"]').val(), 10) || 1;
       var cartCount =  parseInt($('#cart-count').text()) + quantity;
       $('#cart-count').text(cartCount);
     	$("#cart-target").show();
     $("a.cart").removeClass("hide_cart");
     
    };
  
    Shopify.onError = function(XMLHttpRequest, textStatus) {
      // Shopify returns a description of the error in XMLHttpRequest.responseText.
      // It is JSON.
      // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
      var data = eval('(' + XMLHttpRequest.responseText + ')');
      if (!!data.message) {
        alert(data.message + '(' + data.status  + '): ' + data.description);
      } else {
        alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
      }

      $('.addtocart').removeAttr("disabled");
    };

    Shopify.fullMessagesFromErrors = function(errors) {
      var fullMessages = [];
      jQuery.each(errors, function(attribute, messages) {
        jQuery.each(messages, function(index, message) {
          fullMessages.push(attribute + ' ' + message);
        });
      });
      return fullMessages;
    };

})

jQuery(window).load(function(){

  if ( $('.slides li').size() > 1 ) {

    $('.flexslider').flexslider({
      animation: "slide",
      slideshow: true,
      animationDuration: 700,
      slideshowSpeed: 6000,
      animation: "fade",
      controlsContainer: ".flex-controls",
      controlNav: false,
      keyboardNav: true
    }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});

  }

  $("select.loc_on_change").change(function(){
  	if($(this).attr("value") == "#") return false;
  	window.location = $(this).attr("value");
  });

  
});

/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
  // newImageSrc is the path of the new image in the same size as originalImage is sized.
  // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
  // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
  jQuery(mainImageDomEl).attr('src', newImageSrc);
  
  $(mainImageDomEl).parents('a').attr('href', newImageSrc);
  
};

   
jQuery(document).ready(function($){
    	
  $("a.zoom").fancybox({
    padding:0,
    'titleShow': false,
    overlayColor: '#000000',
    overlayOpacity: 0.2
  });
  
  /* Update main product image when a thumbnail is clicked. */
  /*==========================*/
  $('#product .thumbs a').on('click', function(e) { 
    e.preventDefault();
    switchImage($(this).attr('href'), null, $('.featured img')[0]);
  } );
  
  
  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
   
  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })
  
 
  
  $(".search_box").attr("placeholder","");
  
  $("#mail-pop").click(function(e){
    e.preventDefault();
  	$("#newsletter").show();
  });
  
   $('#mobile-nav').sidr();
  
  
}); // end document ready

/* jQuery css bezier animation support -- Jonah Fox */
 
;(function($){
 
  $.path = {};
 
  var V = {
    rotate: function(p, degrees) {
      var radians = degrees * Math.PI / 180,
        c = Math.cos(radians),
        s = Math.sin(radians);
      return [c*p[0] - s*p[1], s*p[0] + c*p[1]];
    },
    scale: function(p, n) {
      return [n*p[0], n*p[1]];
    },
    add: function(a, b) {
      return [a[0]+b[0], a[1]+b[1]];
    },
    minus: function(a, b) {
      return [a[0]-b[0], a[1]-b[1]];
    }
  };
 
  $.path.bezier = function( params, rotate ) {
    params.start = $.extend( {angle: 0, length: 0.3333}, params.start );
    params.end = $.extend( {angle: 0, length: 0.3333}, params.end );
 
    this.p1 = [params.start.x, params.start.y];
    this.p4 = [params.end.x, params.end.y];
 
    var v14 = V.minus( this.p4, this.p1 ),
      v12 = V.scale( v14, params.start.length ),
      v41 = V.scale( v14, -1 ),
      v43 = V.scale( v41, params.end.length );
 
    v12 = V.rotate( v12, params.start.angle );
    this.p2 = V.add( this.p1, v12 );
 
    v43 = V.rotate(v43, params.end.angle );
    this.p3 = V.add( this.p4, v43 );
 
    this.f1 = function(t) { return (t*t*t); };
    this.f2 = function(t) { return (3*t*t*(1-t)); };
    this.f3 = function(t) { return (3*t*(1-t)*(1-t)); };
    this.f4 = function(t) { return ((1-t)*(1-t)*(1-t)); };
 
    /* p from 0 to 1 */
    this.css = function(p) {
      var f1 = this.f1(p), f2 = this.f2(p), f3 = this.f3(p), f4=this.f4(p), css = {};
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( this.p1[0]*f1 + this.p2[0]*f2 +this.p3[0]*f3 + this.p4[0]*f4 +.5 )|0;
      css.y = this.y = ( this.p1[1]*f1 + this.p2[1]*f2 +this.p3[1]*f3 + this.p4[1]*f4 +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };
 
  $.path.arc = function(params, rotate) {
    for ( var i in params ) {
      this[i] = params[i];
    }
 
    this.dir = this.dir || 1;
 
    while ( this.start > this.end && this.dir > 0 ) {
      this.start -= 360;
    }
 
    while ( this.start < this.end && this.dir < 0 ) {
      this.start += 360;
    }
 
    this.css = function(p) {
      var a = ( this.start * (p ) + this.end * (1-(p )) ) * Math.PI / 180,
        css = {};
 
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( Math.sin(a) * this.radius + this.center[0] +.5 )|0;
      css.y = this.y = ( Math.cos(a) * this.radius + this.center[1] +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };
 
  $.fx.step.path = function(fx) {
    var css = fx.end.css( 1 - fx.pos );
    if ( css.prevX != null ) {
      $.cssHooks.transform.set( fx.elem, "rotate(" + Math.atan2(css.prevY - css.y, css.prevX - css.x) + ")" );
    }
    fx.elem.style.top = css.top;
    fx.elem.style.left = css.left;
  };
 
})(jQuery);


$(document).ready(function(){
  
  $(document).on("click",".product_thumbs a",function(event){
  	event.preventDefault();
    var $src=$(this).data("original-image");
    switchImage($(this).attr('href'), null, $(".lv_product .featured img")[0]);
  })
  
  if($("#collection").length > 0){
	$(document).on("click",".expand_product",function(event){
		event.preventDefault();
		//$(".row.products").find(".product").removeClass("active");
		//$(this).parents(".product").addClass("active");
        var $id = $(this).parents(".product");
		//setTimeout(function() { $('html, body').animate({ scrollTop: $id.offset().top }, 200);  }, 400);
        var $url=$(this).attr("href");
		$id.find(".product_description").html("");
		$(".lv_product").remove();
		if($id.hasClass("productgrid1") || $id.hasClass("productgrid4") || $id.hasClass("productgrid5") ) $div=$id.parents(".lv_product_div").next(".lv_product_div").after('<div class="lv_product"></div>');
		if($id.hasClass("productgrid2") || $id.hasClass("productgrid3") || $id.hasClass("productgrid6")) $div=$id.parents(".lv_product_div").after('<div class="lv_product"></div>');
      

        $.ajax({url:$url, dataType : 'html',
          success: function (data) {    
            var obj  = $(data);
            var  elem = obj.find("#product");        
			  $(".lv_product").html("").append(elem);
			  var $pid=$id.data("product_id");
			  var funcName = 'runme' + $pid;
			  if (typeof(window[funcName]) === "function"){
				  window[funcName]();
				}else{ throw("Error.  Function " + funcName + " does not exist.");
		  	 }
             $('html, body').animate({ scrollTop: $(".lv_product").offset().top-100 }, 1000);
            
            $("a.zoom").fancybox({
              padding:0,
              'titleShow': false,
              overlayColor: '#000000',
              overlayOpacity: 0.2
            });
            
             $(".lv_product" ).hover(
              function() {
                $( "#collection" ).addClass( "hover" );
              }, function() {
                $( "#collection" ).removeClass( "hover" );
              }
            );
          }
      });
	});
 }
});